"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7410],{

/***/ 6314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ MAX_PAYLOAD_SIZE; },
/* harmony export */   "f": function() { return /* binding */ IDEAL_PAYLOAD_SIZE; }
/* harmony export */ });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
const IDEAL_PAYLOAD_SIZE = 64000;
const MAX_PAYLOAD_SIZE = 1000000;

/***/ }),

/***/ 1478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ cleanURL; }
/* harmony export */ });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

var patternWithHash = /([^?#]*)[^#]*(#[^?]*|$).*/;
var patternWithoutHash = /([^?#]*)().*/;

/**
 * Cleans a URL by removing the query string and fragment (hash portion).
 * @param {string} url - The original URL to be cleaned.
 * @param {boolean} [keepHash=false] - Whether to preserve the hash portion of the URL.
 * @returns {string} The cleaned URL.
 */
function cleanURL(url, keepHash) {
  return url.replace(keepHash ? patternWithHash : patternWithoutHash, '$1$2');
}

/***/ }),

/***/ 9306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j6": function() { return /* binding */ obj; },
/* harmony export */   "wu": function() { return /* binding */ param; }
/* harmony export */ });
/* unused harmony exports qs, fromArray */
/* harmony import */ var _util_stringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4155);
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */



// Characters that are safe in a qs, but get encoded.
var charMap = {
  '%2C': ',',
  '%3A': ':',
  '%2F': '/',
  '%40': '@',
  '%24': '$',
  '%3B': ';'
};
var charList = Object.keys(charMap);
var safeEncoded = new RegExp(charList.join('|'), 'g');
function real(c) {
  return charMap[c];
}

// Encode as URI Component, then unescape anything that is ok in the
// query string position.
function qs(value) {
  if (value === null || value === undefined) return 'null';
  return encodeURIComponent(value).replace(safeEncoded, real);
}
function fromArray(qs, maxBytes) {
  var bytes = 0;
  for (var i = 0; i < qs.length; i++) {
    bytes += qs[i].length;
    if (bytes > maxBytes) return qs.slice(0, i).join('');
  }
  return qs.join('');
}
function obj(payload, maxBytes) {
  var total = 0;
  var result = '';
  Object.entries(payload || {}).forEach(([feature, dataArray]) => {
    var intermediate = [];
    var next;
    var i;
    if (typeof dataArray === 'string' || !Array.isArray(dataArray) && dataArray !== null && dataArray !== undefined && dataArray.toString().length) {
      next = '&' + feature + '=' + qs(dataArray);
      total += next.length;
      result += next;
    } else if (Array.isArray(dataArray) && dataArray.length) {
      total += 9;
      for (i = 0; i < dataArray.length; i++) {
        next = qs((0,_util_stringify__WEBPACK_IMPORTED_MODULE_0__/* .stringify */ .P)(dataArray[i]));
        total += next.length;
        if (typeof maxBytes !== 'undefined' && total >= maxBytes) break;
        intermediate.push(next);
      }
      result += '&' + feature + '=%5B' + intermediate.join(',') + '%5D';
    }
  });
  return result;
}

// Constructs an HTTP parameter to add to the BAM router URL
function param(name, value, base = {}) {
  if (Object.keys(base).includes(name)) return ''; // we assume if feature supplied a matching qp to the base, we should honor what the feature sent over the default
  if (value && typeof value === 'string') {
    return '&' + name + '=' + qs(value);
  }
  return '';
}

/***/ }),

/***/ 8584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ isFileProtocol; }
/* harmony export */ });
/* harmony import */ var _constants_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9152);
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

function isFileProtocol() {
  return Boolean(_constants_runtime__WEBPACK_IMPORTED_MODULE_0__/* .globalScope */ ._A?.location?.protocol === 'file:');
}

/***/ }),

/***/ 7410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* binding */ AggregateBase; }
});

// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/utils/feature-base.js
var feature_base = __webpack_require__(3400);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/config/info.js
var info = __webpack_require__(8312);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/loaders/configure/configure.js + 3 modules
var configure = __webpack_require__(2632);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/window/nreum.js
var nreum = __webpack_require__(3131);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/drain/drain.js
var drain = __webpack_require__(1019);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/feature-flags.js
var feature_flags = __webpack_require__(5097);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/url/protocol.js
var protocol = __webpack_require__(8584);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/console.js
var console = __webpack_require__(1639);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/obfuscate.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */



/**
 * Represents an obfuscation rule that can be applied to harvested payloads
 * @typedef {object} ObfuscationRule
 * @property {string|RegExp} regex The regular expression to match against in the payload
 * @property {string} [replacement] The string to replace the matched regex with
 */

/**
 * Represents an obfuscation rule validation state
 * @typedef {object} ObfuscationRuleValidation
 * @property {ObfuscationRule} rule The original rule validated
 * @property {boolean} isValid Whether the rule is valid
 * @property {object} errors Validation errors
 * @property {boolean} errors.regexMissingDetected Whether the regex is missing
 * @property {boolean} errors.invalidRegexDetected Whether the regex is invalid
 * @property {boolean} errors.invalidReplacementDetected Whether the replacement is invalid
 */

class Obfuscator {
  constructor(agentRef) {
    this.agentRef = agentRef;
    this.warnedRegexMissing = false;
    this.warnedInvalidRegex = false;
    this.warnedInvalidReplacement = false;
  }
  get obfuscateConfigRules() {
    return this.agentRef.init.obfuscate || [];
  }

  /**
   * Applies all valid obfuscation rules to the provided input string
   * @param {string} input String to obfuscate
   * @returns {string}
   */
  obfuscateString(input) {
    // if input is not of type string or is an empty string, short-circuit
    if (typeof input !== 'string' || input.trim().length === 0) return input;
    const rules = this.obfuscateConfigRules.map(rule => this.validateObfuscationRule(rule));
    if ((0,protocol/* isFileProtocol */.V)()) {
      rules.push({
        regex: /^file:\/\/(.*)/,
        replacement: atob('ZmlsZTovL09CRlVTQ0FURUQ=')
      });
    }
    return rules.filter(ruleValidation => ruleValidation.isValid).reduce((input, ruleValidation) => {
      const {
        rule
      } = ruleValidation;
      return input.replace(rule.regex, rule.replacement || '*');
    }, input);
  }

  /**
   * Validates an obfuscation rule and provides errors if any are found.
   * @param {ObfuscationRule} rule The rule to validate
   * @returns {ObfuscationRuleValidation} The validation state of the rule
   */
  validateObfuscationRule(rule) {
    const regexMissingDetected = Boolean(rule.regex === undefined);
    const invalidRegexDetected = Boolean(rule.regex !== undefined && typeof rule.regex !== 'string' && !(rule.regex instanceof RegExp));
    const invalidReplacementDetected = Boolean(rule.replacement && typeof rule.replacement !== 'string');
    if (regexMissingDetected && !this.warnedRegexMissing) {
      (0,console/* warn */.Z)(12, rule);
      this.warnedRegexMissing = true;
    } else if (invalidRegexDetected && !this.warnedInvalidRegex) {
      (0,console/* warn */.Z)(13, rule);
      this.warnedInvalidRegex = true;
    }
    if (invalidReplacementDetected && !this.warnedInvalidReplacement) {
      (0,console/* warn */.Z)(14, rule);
      this.warnedInvalidReplacement = true;
    }
    return {
      rule,
      isValid: !regexMissingDetected && !invalidRegexDetected && !invalidReplacementDetected,
      errors: {
        regexMissingDetected,
        invalidRegexDetected,
        invalidReplacementDetected
      }
    };
  }
}
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/loaders/features/features.js
var features = __webpack_require__(4663);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/aggregate/aggregator.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
class Aggregator {
  constructor() {
    this.aggregatedData = {};
  }

  // Items with the same type and name get aggregated together
  // params are example data from the aggregated items
  // metrics are the numeric values to be aggregated

  store(type, name, params, newMetrics, customParams) {
    var bucket = this.#getBucket(type, name, params, customParams);
    bucket.metrics = aggregateMetrics(newMetrics, bucket.metrics);
    return bucket;
  }
  merge(type, name, metrics, params, customParams, overwriteParams = false) {
    var bucket = this.#getBucket(type, name, params, customParams);
    if (overwriteParams) bucket.params = params; // replace current params with incoming params obj

    if (!bucket.metrics) {
      bucket.metrics = metrics;
      return;
    }
    var oldMetrics = bucket.metrics;
    oldMetrics.count += metrics.count;

    // iterate through each new metric and merge
    Object.keys(metrics || {}).forEach(key => {
      // count is a special case handled above
      if (key === 'count') return;
      var oldMetric = oldMetrics[key];
      var newMetric = metrics[key];

      // handling the case where newMetric is a single-value first
      if (newMetric && !newMetric.c) {
        oldMetrics[key] = updateMetric(newMetric.t, oldMetric);
      } else {
        // newMetric is a metric object
        oldMetrics[key] = mergeMetric(newMetric, oldMetrics[key]);
      }
    });
  }
  storeMetric(type, name, params, value) {
    var bucket = this.#getBucket(type, name, params);
    bucket.stats = updateMetric(value, bucket.stats);
    return bucket;
  }

  // Get all listed types buckets and it deletes the retrieved content from the aggregatedData
  take(types, deleteWhenRetrieved = true) {
    var results = {};
    var type = '';
    var hasData = false;
    for (var i = 0; i < types.length; i++) {
      type = types[i];
      results[type] = Object.values(this.aggregatedData[type] || {});
      if (results[type].length) hasData = true;
      if (deleteWhenRetrieved) delete this.aggregatedData[type];
    }
    return hasData ? results : null;
  }
  #getBucket(type, name, params, customParams) {
    if (!this.aggregatedData[type]) this.aggregatedData[type] = {};
    var bucket = this.aggregatedData[type][name];
    if (!bucket) {
      bucket = this.aggregatedData[type][name] = {
        params: params || {}
      };
      if (customParams) {
        bucket.custom = customParams;
      }
    }
    return bucket;
  }
}
function aggregateMetrics(newMetrics, oldMetrics) {
  if (!oldMetrics) oldMetrics = {
    count: 0
  };
  oldMetrics.count += 1;
  Object.entries(newMetrics || {}).forEach(([key, value]) => {
    oldMetrics[key] = updateMetric(value, oldMetrics[key]);
  });
  return oldMetrics;
}
function updateMetric(value, metric) {
  // when there is no value, then send only count
  if (value == null) {
    return updateCounterMetric(metric);
  }

  // When there is only one data point, the c (count), min, max, and sos (sum of squares) params are superfluous.
  if (!metric) return {
    t: value
  };

  // but on the second data point, we need to calculate the other values before aggregating in new values
  if (!metric.c) {
    metric = createMetricObject(metric.t);
  }

  // at this point, metric is always uncondensed
  metric.c += 1;
  metric.t += value;
  metric.sos += value * value;
  if (value > metric.max) metric.max = value;
  if (value < metric.min) metric.min = value;
  return metric;
}
function updateCounterMetric(metric) {
  if (!metric) {
    metric = {
      c: 1
    };
  } else {
    metric.c++;
  }
  return metric;
}
function mergeMetric(newMetric, oldMetric) {
  if (!oldMetric) return newMetric;
  if (!oldMetric.c) {
    // oldMetric is a single-value
    oldMetric = createMetricObject(oldMetric.t);
  }
  oldMetric.min = Math.min(newMetric.min, oldMetric.min);
  oldMetric.max = Math.max(newMetric.max, oldMetric.max);
  oldMetric.t += newMetric.t;
  oldMetric.sos += newMetric.sos;
  oldMetric.c += newMetric.c;
  return oldMetric;
}

// take a value and create a metric object
function createMetricObject(value) {
  return {
    t: value,
    min: value,
    max: value,
    sos: value * value,
    c: 1
  };
}
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/aggregate/event-aggregator.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */


/**
 * An extension of the Aggregator class that provides an interface similar to that of EventBuffer class.
 * This typecasting allow features that uses Aggregator as their event handler to share the same AggregateBase.events utilization by those features.
 */
class EventAggregator {
  #aggregator = new Aggregator();
  #savedNamesToBuckets = {};
  isEmpty({
    aggregatorTypes
  }) {
    if (!aggregatorTypes) return Object.keys(this.#aggregator.aggregatedData).length === 0;
    return aggregatorTypes.every(type => !this.#aggregator.aggregatedData[type]); // no bucket exist for any of the types we're looking for
  }
  add([type, name, params, newMetrics, customParams]) {
    // Do we need to track byte size here like EventBuffer?
    this.#aggregator.store(type, name, params, newMetrics, customParams);
    return true;
  }
  addMetric(type, name, params, value) {
    this.#aggregator.storeMetric(type, name, params, value);
    return true;
  }
  save({
    aggregatorTypes
  }) {
    const key = aggregatorTypes.toString(); // the stringified types serve as the key to each save call, e.g. ['err', 'ierr', 'xhr'] => 'err,ierr,xhr'
    const backupAggregatedDataSubset = {};
    aggregatorTypes.forEach(type => backupAggregatedDataSubset[type] = this.#aggregator.aggregatedData[type]); // make a subset of the aggregatedData for each of the types we want to save
    this.#savedNamesToBuckets[key] = backupAggregatedDataSubset;
    /*
    { 'err,ierr,xhr': {
        'err': {
            <aggregateHash>: { metrics: { count: 1, time, ... }, params: {}, custom: {} },
            <otherHashName>: { metrics: { count: 1, ... }, ... }
        },
        'ierr': { ... },
        'xhr': { ... }
      }
    }
    */
  }
  get(opts) {
    const aggregatorTypes = Array.isArray(opts) ? opts : opts.aggregatorTypes;
    return this.#aggregator.take(aggregatorTypes, false);
  }
  clear({
    aggregatorTypes
  } = {}) {
    if (!aggregatorTypes) {
      this.#aggregator.aggregatedData = {};
      return;
    }
    aggregatorTypes.forEach(type => delete this.#aggregator.aggregatedData[type]);
  }
  reloadSave({
    aggregatorTypes
  }) {
    const key = aggregatorTypes.toString();
    const backupAggregatedDataSubset = this.#savedNamesToBuckets[key];
    // Grabs the previously stored subset and merge it back into aggregatedData.
    aggregatorTypes.forEach(type => {
      Object.keys(backupAggregatedDataSubset[type] || {}).forEach(name => {
        const bucket = backupAggregatedDataSubset[type][name];
        // The older aka saved params take effect over the newer one. This is especially important when merging back for a failed harvest retry if, for example,
        // the first-ever occurrence of an error is in the retry: it contains the params.stack_trace whereas the newer or current bucket.params would not.
        this.#aggregator.merge(type, name, bucket.metrics, bucket.params, bucket.custom, true);
      });
    });
  }
  clearSave({
    aggregatorTypes
  }) {
    const key = aggregatorTypes.toString();
    delete this.#savedNamesToBuckets[key];
  }
}
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/dispatch/global-event.js
var global_event = __webpack_require__(5634);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/utils/event-buffer.js
var event_buffer = __webpack_require__(2493);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/utils/event-store-manager.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */





/**
 * This layer allows multiple browser entity apps, or "target", to each have their own segregated storage instance.
 * The purpose is so the harvester can send data to different apps within the same agent. Each feature should have a manager if it needs this capability.
 */
class EventStoreManager {
  /**
   * @param {object} defaultTarget - should contain licenseKey and appId of the main app from NREUM.info at startup
   * @param {1|2} storageChoice - the type of storage to use in this manager; 'EventBuffer' (1), 'EventAggregator' (2)
   * @param {string} agentIdentifier - agent identifier used in inspection events
   * @param {string} featureName - feature name used in inspection events for non-shared aggregators
   */
  constructor(defaultTarget, storageChoice, agentIdentifier, featureName) {
    this.mainApp = defaultTarget;
    this.StorageClass = storageChoice === 1 ? event_buffer/* EventBuffer */.X : EventAggregator;
    this.appStorageMap = new Map();
    this.appStorageMap.set(defaultTarget, new this.StorageClass());
    this.agentIdentifier = agentIdentifier;
    this.featureName = featureName;
  }

  // This class must contain an union of all methods from all supported storage classes and conceptualize away the target app argument.

  /**
   * @param {object} optsIfPresent - exists if called during harvest interval, @see AggregateBase.makeHarvestPayload
   * @param {object} target - specific app's storage to check; if not provided, this method takes into account all apps recorded by this manager
   * @returns {boolean} True if the target's storage is empty, or target does not exist in map (defaults to all storages)
   */
  isEmpty(optsIfPresent, target) {
    if (target) {
      if (!this.appStorageMap.has(target)) return true;else return this.appStorageMap.get(target).isEmpty(optsIfPresent);
    }
    for (const eventStore of this.appStorageMap.values()) {
      if (!eventStore.isEmpty(optsIfPresent)) return false;
    }
    return true;
  }

  /**
   * @param {string} event - the event element to store
   * @param {object} target - the app to store event under; if not provided, this method adds to the main app from NREUM.info
   * @returns {boolean} True if the event was successfully added
   */
  add(event, target) {
    (0,global_event/* dispatchGlobalEvent */.i)({
      agentIdentifier: this.agentIdentifier,
      loaded: !!feature_flags/* activatedFeatures */.T?.[this.agentIdentifier],
      type: 'data',
      name: 'buffer',
      feature: this.featureName,
      data: event
    });
    if (target && !this.appStorageMap.has(target)) this.appStorageMap.set(target, new this.StorageClass());
    return this.appStorageMap.get(target || this.mainApp).add(event);
  }

  /** This is only used by the Metrics feature which has no need to add metric under a different app atm. */
  addMetric(type, name, params, value) {
    return this.appStorageMap.get(this.mainApp).addMetric(type, name, params, value);
  }

  /**
   * @param {object} optsIfPresent - exists if called during harvest interval, @see AggregateBase.makeHarvestPayload
   * @param {object} target - specific app to fetch; if not provided, this method fetches from all apps
   * @returns {Array} Objects of `data` labeled with their respective `target` app to be sent to
   */
  get(optsIfPresent, target) {
    if (target) return [{
      targetApp: target,
      data: this.appStorageMap.get(target)?.get(optsIfPresent)
    }];
    const allPayloads = [];
    this.appStorageMap.forEach((eventStore, recordedTarget) => {
      allPayloads.push({
        targetApp: recordedTarget,
        data: eventStore.get(optsIfPresent)
      });
    });
    return allPayloads;
  }
  byteSize(target) {
    return this.appStorageMap.get(target || this.mainApp).byteSize();
  }
  wouldExceedMaxSize(incomingSize, target) {
    return this.appStorageMap.get(target || this.mainApp).wouldExceedMaxSize(incomingSize);
  }
  save(optsIfPresent, target) {
    if (target) return this.appStorageMap.get(target)?.save(optsIfPresent);
    this.appStorageMap.forEach(eventStore => eventStore.save(optsIfPresent));
  }
  clear(optsIfPresent, target) {
    if (target) return this.appStorageMap.get(target)?.clear(optsIfPresent);
    this.appStorageMap.forEach(eventStore => eventStore.clear(optsIfPresent));
  }

  // Unlike the methods above, the following will have a target as they are called by AggregateBase.postHarvestCleanup callback on harvest finish after getting & sending the data.
  reloadSave(optsIfPresent, target) {
    if (!target) {
      // -- remove this block once the old harvest.js & harvest-schedule.js are deleted!
      this.appStorageMap.forEach(eventStore => eventStore.reloadSave(optsIfPresent));
      return;
    }
    return this.appStorageMap.get(target)?.reloadSave(optsIfPresent);
  }
  clearSave(optsIfPresent, target) {
    if (!target) {
      // -- remove this block once the old harvest.js & harvest-schedule.js are deleted!
      this.appStorageMap.forEach(eventStore => eventStore.clearSave(optsIfPresent));
      return;
    }
    return this.appStorageMap.get(target)?.clearSave(optsIfPresent);
  }
}
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/metrics/constants.js + 1 modules
var constants = __webpack_require__(3705);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/constants/env.npm.js
var env_npm = __webpack_require__(8445);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/constants/runtime.js
var runtime = __webpack_require__(9152);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-emitter/handle.js
var handle = __webpack_require__(5300);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-listener/event-listener-opts.js
var event_listener_opts = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/session/constants.js
var session_constants = __webpack_require__(9181);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/timing/now.js
var now = __webpack_require__(1595);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/window/page-visibility.js
var page_visibility = __webpack_require__(7973);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/unload/eol.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */


if (runtime/* isWorkerScope */.v6) {
  runtime/* globalScope.cleanupTasks */._A.cleanupTasks = []; // create new list on WorkerGlobalScope to track funcs to run before exiting thread

  const origClose = runtime/* globalScope.close */._A.close;
  runtime/* globalScope.close */._A.close = () => {
    // on worker's EoL signal, execute all "listeners", e.g. final harvests
    for (let task of runtime/* globalScope.cleanupTasks */._A.cleanupTasks) {
      task();
    }
    origClose();
  };
}

/**
 * Subscribes a provided callback to the time/event when the agent should treat it as end-of-life.
 * This is used, for example, to submit a final harvest and send all remaining data on best-effort.
 * @param {function} cb - func to run before or during the last reliable event or time of an env's life span
 */
function subscribeToEOL(cb, capturePhase) {
  if (runtime/* isBrowserScope */.il) {
    (0,page_visibility/* subscribeToVisibilityChange */.N)(cb, true, capturePhase); // when user switches tab or hides window, esp. mobile scenario
  } else if (runtime/* isWorkerScope */.v6) {
    runtime/* globalScope.cleanupTasks.push */._A.cleanupTasks.push(cb); // close() should run these tasks before quitting thread
  }
  // By default (for other env), this fn has no effect.
}
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/url/clean-url.js
var clean_url = __webpack_require__(1478);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/url/encode.js
var encode = __webpack_require__(9306);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/stringify.js
var stringify = __webpack_require__(4155);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/submit-data.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @file Contains common methods used to transmit harvested data.
 * @copyright 2023 New Relic Corporation. All rights reserved.
 * @license Apache-2.0
 */



/**
 * @typedef {xhr|beacon} NetworkMethods
 */

/**
 * Determines the submit method to use based on options.
 * @param {object} opts Options used to determine submit method.
 * @param {boolean} opts.isFinalHarvest Indicates if the data submission is due to
 * a final harvest within the agent.
 */
function getSubmitMethod({
  isFinalHarvest = false
} = {}) {
  if (isFinalHarvest && runtime/* isBrowserScope */.il) {
    // Use sendBeacon for final harvest
    return beacon;
  }

  // If not final harvest, or not browserScope, use XHR post if available
  if (typeof XMLHttpRequest !== 'undefined') {
    return xhr;
  }

  // Fallback for web workers where XMLHttpRequest is not available
  return xhrFetch;
}

/**
 *
 * @param url
 * @param body
 * @param method
 * @param headers
 * @returns {Promise<Response>}
 */
function xhrFetch({
  url,
  body = null,
  method = 'POST',
  headers = [{
    key: 'content-type',
    value: 'text/plain'
  }]
}) {
  const objHeaders = {};
  for (const header of headers) {
    objHeaders[header.key] = header.value;
  }
  return fetch(url, {
    headers: objHeaders,
    method,
    body,
    credentials: 'include'
  });
}

/**
 * Send via XHR
 * @param {Object} args - The args.
 * @param {string} args.url - The URL to send to.
 * @param {string=} args.body - The Stringified body. Default null to prevent IE11 from breaking.
 * @param {boolean=} args.sync - Run XHR synchronously.
 * @param {string=} [args.method=POST] - The XHR method to use.
 * @param {{key: string, value: string}[]} [args.headers] - The headers to attach.
 * @returns {XMLHttpRequest}
 */
function xhr({
  url,
  body = null,
  sync,
  method = 'POST',
  headers = [{
    key: 'content-type',
    value: 'text/plain'
  }]
}) {
  const request = new XMLHttpRequest();
  request.open(method, url, !sync);
  try {
    // Set cookie
    if ('withCredentials' in request) request.withCredentials = true;
  } catch (e) {
    // do nothing
  }
  headers.forEach(header => {
    request.setRequestHeader(header.key, header.value);
  });
  request.send(body);
  return request;
}

/**
 * Send via sendBeacon. Do NOT call this function outside of a guaranteed web window environment.
 * @param {Object} args - The args
 * @param {string} args.url - The URL to send to
 * @param {string=} args.body - The Stringified body
 * @returns {boolean}
 */
function beacon({
  url,
  body
}) {
  try {
    // Navigator has to be bound to ensure it does not error in some browsers
    // https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
    const send = window.navigator.sendBeacon.bind(window.navigator);
    return send(url, body);
  } catch (err) {
    // if sendBeacon still trys to throw an illegal invocation error,
    // we can catch here and return
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/harvest/harvester.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
















const RETRY_FAILED = 'Harvester/Retry/Failed/';
const RETRY_SUCCEEDED = 'Harvester/Retry/Succeeded/';
class Harvester {
  #started = false;
  initializedAggregates = [];
  constructor(agentRef) {
    this.agentRef = agentRef;
    subscribeToEOL(() => {
      // do one last harvest round or check
      this.initializedAggregates.forEach(aggregateInst => {
        // let all features wrap up things needed to do before ANY harvest in case there's last minute cross-feature data dependencies
        if (typeof aggregateInst.harvestOpts.beforeUnload === 'function') aggregateInst.harvestOpts.beforeUnload();
      });
      this.initializedAggregates.forEach(aggregateInst => this.triggerHarvestFor(aggregateInst, {
        isFinalHarvest: true
      }));
      /* This callback should run in bubble phase, so that that CWV api, like "onLCP", is called before the final harvest so that emitted timings are part of last outgoing. */
    }, false);

    /* Flush all buffered data if session resets and give up retries. This should be synchronous to ensure that the correct `session` value is sent.
      Since session-reset generates a new session ID and the ID is grabbed at send-time, any delays or retries would cause the payload to be sent under the wrong session ID. */
    agentRef.ee.on(session_constants/* SESSION_EVENTS.RESET */.wO.RESET, () => this.initializedAggregates.forEach(aggregateInst => this.triggerHarvestFor(aggregateInst, {
      forceNoRetry: true
    })));
  }
  startTimer(harvestInterval = this.agentRef.init.harvest.interval) {
    if (this.#started) return;
    this.#started = true;
    const onHarvestInterval = () => {
      this.initializedAggregates.forEach(aggregateInst => this.triggerHarvestFor(aggregateInst));
      setTimeout(onHarvestInterval, harvestInterval * 1000); // repeat in X seconds
    };
    setTimeout(onHarvestInterval, harvestInterval * 1000);
  }

  /**
   * Given a feature (aggregate), execute a harvest on-demand.
   * @param {object} aggregateInst
   * @param {object} localOpts
   * @returns {boolean} True if 1+ network call was made. Note that this does not mean or guarantee that it was successful (or that all were in the case of more than 1).
   */
  triggerHarvestFor(aggregateInst, localOpts = {}) {
    if (aggregateInst.blocked) return false;
    const submitMethod = getSubmitMethod(localOpts);
    if (!submitMethod) return false;
    const shouldRetryOnFail = !localOpts.isFinalHarvest && submitMethod === xhr; // always retry all features harvests except for final
    let dataToSendArr;
    let ranSend = false;
    if (!localOpts.directSend) {
      // primarily used by rum call to bypass makeHarvestPayload by providing payload directly
      dataToSendArr = aggregateInst.makeHarvestPayload(shouldRetryOnFail, localOpts); // be sure the 'this' of makeHarvestPayload is the aggregate w/ access to its harvestOpts
      if (!dataToSendArr) return false; // can be undefined if storage is empty or preharvest checks failed
    } else dataToSendArr = [localOpts.directSend];
    dataToSendArr.forEach(({
      targetApp,
      payload
    }) => {
      if (!payload) return;
      send(this.agentRef, {
        endpoint: features/* FEATURE_TO_ENDPOINT */.r3[aggregateInst.featureName],
        targetApp,
        payload,
        localOpts,
        submitMethod,
        cbFinished,
        raw: aggregateInst.harvestOpts.raw,
        featureName: aggregateInst.featureName
      });
      ranSend = true;
    });
    return ranSend;

    /**
     * This is executed immediately after harvest sends the data via XHR, or if there's nothing to send. Note that this excludes on unloading / sendBeacon.
     * @param {Object} result - information regarding the result of the harvest attempt
     */
    function cbFinished(result) {
      if (aggregateInst.harvestOpts.prevAttemptCode) {
        // this means we just retried a harvest that last failed
        (0,handle/* handle */.p)(constants/* SUPPORTABILITY_METRIC_CHANNEL */.xS, [(result.retry ? RETRY_FAILED : RETRY_SUCCEEDED) + aggregateInst.harvestOpts.prevAttemptCode], undefined, features/* FEATURE_NAMES.metrics */.DT.metrics, aggregateInst.ee);
        delete aggregateInst.harvestOpts.prevAttemptCode; // always reset last observation so we don't falsely report again next harvest
        // In case this re-attempt failed again, that'll be handled (re-marked again) next.
      }
      if (result.retry) aggregateInst.harvestOpts.prevAttemptCode = result.status; // earmark this Agg harvest as failed-but-retrying for next harvest trigger so we can capture metrics about retries

      if (localOpts.forceNoRetry) result.retry = false; // discard unsent data rather than re-queuing for next harvest attempt; used by session reset to flush data belonging to prev session
      aggregateInst.postHarvestCleanup(result);
    }
  }
}

/**
 * @typedef {import('./types.js').NetworkSendSpec} NetworkSendSpec
 */

const warnings = {};
/**
  * Initiate a harvest call.
  * @param {NetworkSendSpec} param0 Specification for sending data
  * @returns {boolean} True if a network call was made. Note that this does not mean or guarantee that it was successful.
  */
function send(agentRef, {
  endpoint,
  targetApp,
  payload,
  localOpts = {},
  submitMethod,
  cbFinished,
  raw,
  featureName
}) {
  if (!agentRef.info.errorBeacon) return false;
  let {
    body,
    qs
  } = cleanPayload(payload);
  if (Object.keys(body).length === 0 && !localOpts.sendEmptyBody) {
    // if there's no body to send, just run onfinish stuff and return
    if (cbFinished) cbFinished({
      sent: false,
      targetApp
    });
    return false;
  }
  const protocol = agentRef.init.ssl === false ? 'http' : 'https';
  const perceivedBeacon = agentRef.init.proxy.beacon || agentRef.info.errorBeacon;
  const url = raw ? "".concat(protocol, "://").concat(perceivedBeacon, "/").concat(endpoint) : "".concat(protocol, "://").concat(perceivedBeacon).concat(endpoint !== features/* RUM */.tr ? '/' + endpoint : '', "/1/").concat(targetApp.licenseKey);
  const baseParams = !raw ? baseQueryString(agentRef, qs, endpoint, targetApp.appId) : '';
  let payloadParams = (0,encode/* obj */.j6)(qs, agentRef.runtime.maxBytes);
  if (baseParams === '' && payloadParams.startsWith('&')) {
    payloadParams = payloadParams.substring(1);
  }
  const fullUrl = "".concat(url, "?").concat(baseParams).concat(payloadParams);
  const gzip = !!qs?.attributes?.includes('gzip');
  if (!gzip) {
    if (endpoint !== features/* EVENTS */.FP) body = (0,stringify/* stringify */.P)(body); // all features going to 'events' endpoint should already be serialized & stringified
    // Warn--once per endpoint--if the agent tries to send large payloads
    if (body.length > 750000 && (warnings[endpoint] = (warnings[endpoint] || 0) + 1) === 1) (0,console/* warn */.Z)(28, endpoint);
  }

  // If body is null, undefined, or an empty object or array after stringifying, send an empty string instead.
  if (!body || body.length === 0 || body === '{}' || body === '[]') body = '';
  const headers = [{
    key: 'content-type',
    value: 'text/plain'
  }];

  /* Since workers don't support sendBeacon right now, they can only use XHR method.
      Because they still do permit synch XHR, the idea is that at final harvest time (worker is closing),
      we just make a BLOCKING request--trivial impact--with the remaining data as a temp fill-in for sendBeacon.
     Following the removal of img-element method. */
  let result = submitMethod({
    url: fullUrl,
    body,
    sync: localOpts.isFinalHarvest && runtime/* isWorkerScope */.v6,
    headers
  });
  if (!localOpts.isFinalHarvest && cbFinished) {
    // final harvests don't hold onto buffer data (shouldRetryOnFail is false), so cleanup isn't needed
    if (submitMethod === xhr) {
      result.addEventListener('loadend', function () {
        // `this` here in block refers to the XHR object in this scope, do not change the anon function to an arrow function
        // status 0 refers to a local error, such as CORS or network failure, or a blocked request by the browser (e.g. adblocker)
        const cbResult = {
          sent: this.status !== 0,
          status: this.status,
          retry: shouldRetry(this.status),
          xhr: this,
          fullUrl,
          targetApp
        };
        if (localOpts.needResponse) cbResult.responseText = this.responseText;
        cbFinished(cbResult);
      }, (0,event_listener_opts/* eventListenerOpts */.m$)(false));
    } else if (submitMethod === xhrFetch) {
      result.then(async function (response) {
        const status = response.status;
        const cbResult = {
          sent: true,
          status,
          retry: shouldRetry(status),
          fullUrl,
          fetchResponse: response,
          targetApp
        };
        if (localOpts.needResponse) cbResult.responseText = await response.text();
        cbFinished(cbResult);
      });
    }
  }
  (0,global_event/* dispatchGlobalEvent */.i)({
    agentIdentifier: agentRef.agentIdentifier,
    loaded: !!feature_flags/* activatedFeatures */.T?.[agentRef.agentIdentifier],
    type: 'data',
    name: 'harvest',
    feature: featureName,
    data: {
      endpoint,
      headers,
      targetApp,
      payload,
      submitMethod: getSubmitMethodName(),
      raw,
      synchronousXhr: !!(localOpts.isFinalHarvest && runtime/* isWorkerScope */.v6)
    }
  });
  return true;
  function shouldRetry(status) {
    switch (status) {
      case 408:
      case 429:
      case 500:
        return true;
    }
    return status >= 502 && status <= 504 || status >= 512 && status <= 530;
  }
  function getSubmitMethodName() {
    if (submitMethod === xhr) return 'xhr';
    if (submitMethod === xhrFetch) return 'fetch';
    return 'beacon';
  }
}

/**
 * Cleans and returns a payload object containing a body and qs
 * object with key/value pairs. KV pairs where the value is null,
 * undefined, or an empty string are removed to save on transmission
 * size.
 * @param {HarvestPayload} payload Payload to be sent to the endpoint.
 * @returns {HarvestPayload} Cleaned payload payload to be sent to the endpoint.
 */
function cleanPayload(payload = {}) {
  const clean = input => {
    if (typeof Uint8Array !== 'undefined' && input instanceof Uint8Array || Array.isArray(input)) return input;
    if (typeof input === 'string') return input.length > 0 ? input : null;
    return Object.entries(input || {}).reduce((accumulator, [key, value]) => {
      if (typeof value === 'number' || typeof value === 'string' && value.length > 0 || typeof value === 'object' && Object.keys(value || {}).length > 0) {
        accumulator[key] = value;
      }
      return accumulator;
    }, {});
  };
  return {
    body: clean(payload.body),
    qs: clean(payload.qs)
  };
}

// The stuff that gets sent every time.
function baseQueryString(agentRef, qs, endpoint, applicationID) {
  const ref = agentRef.runtime.obfuscator.obfuscateString((0,clean_url/* cleanURL */.f)('' + runtime/* globalScope.location */._A.location));
  const hr = agentRef.runtime.session?.state.sessionReplayMode === 1 && endpoint !== features/* JSERRORS */.Mg;
  const ht = agentRef.runtime.session?.state.sessionTraceMode === 1 && ![features/* LOGS */.SP, features/* BLOBS */.NQ].includes(endpoint);
  const qps = ['a=' + applicationID, (0,encode/* param */.wu)('sa', agentRef.info.sa ? '' + agentRef.info.sa : ''), (0,encode/* param */.wu)('v', env_npm/* VERSION */.q4), transactionNameParam(), (0,encode/* param */.wu)('ct', agentRef.runtime.customTransaction), '&rst=' + (0,now/* now */.z)(), '&ck=0',
  // ck param DEPRECATED - still expected by backend
  '&s=' + (agentRef.runtime.session?.state.value || '0'),
  // the 0 id encaps all untrackable and default traffic
  (0,encode/* param */.wu)('ref', ref), (0,encode/* param */.wu)('ptid', agentRef.runtime.ptid ? '' + agentRef.runtime.ptid : '')];
  if (hr) qps.push((0,encode/* param */.wu)('hr', '1', qs));
  if (ht) qps.push((0,encode/* param */.wu)('ht', '1', qs));
  return qps.join('');

  // Constructs the transaction name param for the beacon URL.
  // Prefers the obfuscated transaction name over the plain text.
  // Falls back to making up a name.
  function transactionNameParam() {
    if (agentRef.info.transactionName) return (0,encode/* param */.wu)('to', agentRef.info.transactionName);
    return (0,encode/* param */.wu)('t', agentRef.info.tNamePlain || 'Unnamed Transaction');
  }
}
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/utils/aggregate-base.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */












class AggregateBase extends feature_base/* FeatureBase */.W {
  constructor(agentRef, featureName) {
    super(agentRef.agentIdentifier, featureName);
    this.agentRef = agentRef;
    this.checkConfiguration(agentRef);
    this.doOnceForAllAggregate(agentRef);

    // This switch needs to be after doOnceForAllAggregate which may new sharedAggregator and reset mainAppKey.
    switch (this.featureName) {
      // SessionTrace + Replay have their own storage mechanisms.
      case features/* FEATURE_NAMES.sessionTrace */.DT.sessionTrace:
      case features/* FEATURE_NAMES.sessionReplay */.DT.sessionReplay:
        break;
      // Jserror and Metric features uses a singleton EventAggregator instead of a regular EventBuffer.
      case features/* FEATURE_NAMES.jserrors */.DT.jserrors:
      case features/* FEATURE_NAMES.metrics */.DT.metrics:
        this.events = agentRef.sharedAggregator;
        break;
      /** All other features get EventBuffer in the ESM by default. Note: PVE is included here, but event buffer will always be empty so future harvests will still not happen by interval or EOL.
      This was necessary to prevent race cond. issues where the event buffer was checked before the feature could "block" itself.
      Its easier to just keep an empty event buffer in place. */
      default:
        this.events = new EventStoreManager(agentRef.mainAppKey, 1, agentRef.agentIdentifier, this.featureName);
        break;
    }
    this.harvestOpts = {}; // features aggregate classes can define custom opts for when their harvest is called
  }

  /**
   * New handler for waiting for multiple flags. Useful when expecting multiple flags simultaneously (ex. stn vs sr)
   * @param {string[]} flagNames
   * @returns {Promise}
   */
  waitForFlags(flagNames = []) {
    const flagsPromise = new Promise((resolve, reject) => {
      if (feature_flags/* activatedFeatures */.T[this.agentIdentifier]) {
        resolve(buildOutput(feature_flags/* activatedFeatures */.T[this.agentIdentifier]));
      } else {
        this.ee.on('rumresp', (resp = {}) => {
          resolve(buildOutput(resp));
        });
      }
      function buildOutput(ref) {
        return flagNames.map(flag => {
          if (!ref[flag]) return 0;
          return ref[flag];
        });
      }
    });
    return flagsPromise.catch(err => {
      this.ee.emit('internal-error', [err]);
      this.blocked = true;
      this.deregisterDrain();
    });
  }
  drain() {
    (0,drain/* drain */.LP)(this.agentIdentifier, this.featureName);
    this.drained = true;
  }
  preHarvestChecks(opts) {
    return !this.blocked;
  }

  /**
   * Return harvest payload. A "serializer" function can be defined on a derived class to format the payload.
   * @param {Boolean} shouldRetryOnFail - harvester flag to backup payload for retry later if harvest request fails; this should be moved to harvester logic
   * @param {object|undefined} opts.target - the target app passed onto the event store manager to determine which app's data to return; if none provided, all apps data will be returned
   * @returns {Array} Final payload tagged with their targeting browser app. The value of `payload` can be undefined if there are no pending events for an app. This should be a minimum length of 1.
   */
  makeHarvestPayload(shouldRetryOnFail = false, opts = {}) {
    if (this.events.isEmpty(this.harvestOpts, opts.target)) return;
    // Other conditions and things to do when preparing harvest that is required.
    if (this.preHarvestChecks && !this.preHarvestChecks(opts)) return;
    if (shouldRetryOnFail) this.events.save(this.harvestOpts, opts.target);
    const returnedDataArr = this.events.get(this.harvestOpts, opts.target);
    if (!returnedDataArr.length) throw new Error('Unexpected problem encountered. There should be at least one app for harvest!');
    this.events.clear(this.harvestOpts, opts.target);
    return returnedDataArr.map(({
      targetApp,
      data
    }) => {
      // A serializer or formatter assists in creating the payload `body` from stored events on harvest when defined by derived feature class.
      const body = this.serializer ? this.serializer(data) : data;
      const payload = {
        body
      };
      // Constructs the payload `qs` for relevant features on harvest.
      if (this.queryStringsBuilder) payload.qs = this.queryStringsBuilder(data);
      return {
        targetApp,
        payload
      };
    });
  }

  /**
   * Cleanup task after a harvest.
   * @param {object} result - the cbResult object from the harvester's send method
   */
  postHarvestCleanup(result = {}) {
    const harvestFailed = result.sent && result.retry;
    if (harvestFailed) this.events.reloadSave(this.harvestOpts, result.targetApp);
    this.events.clearSave(this.harvestOpts, result.targetApp);
  }

  /**
   * Checks for additional `jsAttributes` items to support backward compatibility with implementations of the agent where
   * loader configurations may appear after the loader code is executed.
   */
  checkConfiguration(existingAgent) {
    // NOTE: This check has to happen at aggregator load time
    if (!(0,info/* isValid */.JY)(this.agentIdentifier)) {
      const cdn = (0,nreum/* gosCDN */.gG)();
      let jsAttributes = {
        ...cdn.info?.jsAttributes
      };
      try {
        jsAttributes = {
          ...jsAttributes,
          ...existingAgent.info?.jsAttributes
        };
      } catch (err) {
        // do nothing
      }
      (0,configure/* configure */.j)({
        agentIdentifier: this.agentIdentifier
      }, {
        ...cdn,
        info: {
          ...cdn.info,
          jsAttributes
        },
        runtime: existingAgent.runtime
      });
    }
  }

  /**
   * These are actions related to shared resources that should be initialized once by whichever feature Aggregate subclass loads first.
   * This method should run after checkConfiguration, which may reset the agent's info/runtime object that is used here.
   */
  doOnceForAllAggregate(agentRef) {
    if (!agentRef.runtime.obfuscator) agentRef.runtime.obfuscator = new Obfuscator(agentRef);
    this.obfuscator = agentRef.runtime.obfuscator;
    if (!agentRef.mainAppKey) agentRef.mainAppKey = {
      licenseKey: agentRef.info.licenseKey,
      appId: agentRef.info.applicationID
    };
    // Create a single Aggregator for this agent if DNE yet; to be used by jserror endpoint features.
    if (!agentRef.sharedAggregator) agentRef.sharedAggregator = new EventStoreManager(agentRef.mainAppKey, 2, agentRef.agentIdentifier, 'shared_aggregator');
    if (!agentRef.runtime.harvester) agentRef.runtime.harvester = new Harvester(agentRef);
  }

  /**
   * Report a supportability metric
   * @param {*} metricName The tag of the name matching the Angler aggregation tag
   * @param {*} [value] An optional value to supply. If not supplied, the metric count will be incremented by 1 for every call.
   */
  reportSupportabilityMetric(metricName, value) {
    (0,handle/* handle */.p)(constants/* SUPPORTABILITY_METRIC_CHANNEL */.xS, [metricName, value], undefined, features/* FEATURE_NAMES.metrics */.DT.metrics, this.ee);
  }
}

/***/ }),

/***/ 2493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ EventBuffer; }
/* harmony export */ });
/* harmony import */ var _common_util_stringify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4155);
/* harmony import */ var _common_constants_agent_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6314);
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */


class EventBuffer {
  #buffer = [];
  #rawBytes = 0;
  #bufferBackup;
  #rawBytesBackup;

  /**
   * @param {number} maxPayloadSize
   */
  constructor(maxPayloadSize = _common_constants_agent_constants__WEBPACK_IMPORTED_MODULE_1__/* .MAX_PAYLOAD_SIZE */ .Y) {
    this.maxPayloadSize = maxPayloadSize;
  }
  isEmpty() {
    return this.#buffer.length === 0;
  }
  get() {
    return this.#buffer;
  }
  byteSize() {
    return this.#rawBytes;
  }
  wouldExceedMaxSize(incomingSize) {
    return this.#rawBytes + incomingSize > this.maxPayloadSize;
  }

  /**
   * Add feature-processed event to our buffer. If this event would cause our total raw size to exceed the set max payload size, it is dropped.
   * @param {any} event - any primitive type or object
   * @returns {Boolean} true if successfully added; false otherwise
   */
  add(event) {
    const addSize = (0,_common_util_stringify__WEBPACK_IMPORTED_MODULE_0__/* .stringify */ .P)(event)?.length || 0; // (estimate) # of bytes a directly stringified event it would take to send
    if (this.#rawBytes + addSize > this.maxPayloadSize) return false;
    this.#buffer.push(event);
    this.#rawBytes += addSize;
    return true;
  }

  /**
   * Wipes the main buffer
   */
  clear() {
    this.#buffer = [];
    this.#rawBytes = 0;
  }

  /**
   * Backup the buffered data and clear the main buffer
   */
  save() {
    this.#bufferBackup = this.#buffer;
    this.#rawBytesBackup = this.#rawBytes;
  }

  /**
   * Wipes the backup buffer
   */
  clearSave() {
    this.#bufferBackup = undefined;
    this.#rawBytesBackup = undefined;
  }

  /**
   * Prepend the backup buffer back into the main buffer
   */
  reloadSave() {
    if (!this.#bufferBackup) return;
    if (this.#rawBytesBackup + this.#rawBytes > this.maxPayloadSize) return;
    this.#buffer = [...this.#bufferBackup, ...this.#buffer];
    this.#rawBytes = this.#rawBytesBackup + this.#rawBytes;
  }
}

/***/ })

}]);